import { render, staticRenderFns } from "./IntentsUsagesCharts.vue?vue&type=template&id=1a30d9f1&"
import script from "./IntentsUsagesCharts.vue?vue&type=script&lang=js&"
export * from "./IntentsUsagesCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports